if (!window.customElements.get('header-carousel')) {

    class HeaderCarousel extends HTMLElement {
        constructor() {
            super();
            this.slider = null;
            this.hasInitialized = false;
            this.isAtStart = true;
            this.isAtEnd = false;
        }

        connectedCallback() {
            const sliderContainer = this.querySelector('.keen-slider');
            if (!sliderContainer || sliderContainer.children.length < 2) return;

            whenReady('KeenSlider', () => {
                try {
                    this.initializeSlider(sliderContainer);
                } catch (error) {
                    console.error('Failed to initialize KeenSlider:', error);
                }
            });
        }

        initializeSlider(container) {
            const arrow = this.querySelector('.keen-slider__arrow--cursor');
            let isInNavigationZone = false;

            // Wheel Controls function (from Keen Slider example)
            const WheelControls = (slider) => {
                let touchTimeout;
                let position;
                let wheelActive;

                function dispatch(e, name) {
                    position.x -= e.deltaX;
                    position.y -= e.deltaY;
                    slider.container.dispatchEvent(
                        new CustomEvent(name, {
                            detail: {
                                x: position.x,
                                y: position.y,
                            },
                        })
                    );
                }

                function wheelStart(e) {
                    position = {
                        x: e.pageX,
                        y: e.pageY,
                    };
                    dispatch(e, "ksDragStart");
                }

                function wheel(e) {
                    dispatch(e, "ksDrag");
                }

                function wheelEnd(e) {
                    dispatch(e, "ksDragEnd");
                }

                function eventWheel(e) {
                    e.preventDefault();
                    if (!wheelActive) {
                        wheelStart(e);
                        wheelActive = true;
                    }
                    wheel(e);
                    clearTimeout(touchTimeout);
                    touchTimeout = setTimeout(() => {
                        wheelActive = false;
                        wheelEnd(e);
                    }, 50);
                }

                slider.on("created", () => {
                    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (!isSafari) {
                        slider.container.addEventListener("wheel", eventWheel, {
                            passive: false,
                        });
                    }
                });
            };

            const sliderConfig = {
                loop: false,
                rubberband: false,
                slides: {
                    perView: "auto",
                    spacing: 16
                },
                defaultAnimation: {
                    duration: 450,
                    easing: (t) => {
                        return 1 - Math.pow(1 - t, 3);
                    }
                },
                created(s) {
                    // Ensure slides are properly sized
                    // s.slides.forEach(slide => {
                    //     slide.style.flex = '0 0 auto';
                    // });
                },
                detailsChanged: (s) => {
                    this.isAtStart = s.track.details.rel === 0;
                    this.isAtEnd = s.track.details.rel === s.track.details.maxIdx;
                    this.handleSlideChange(s, container);
                }
            };

            this.slider = new window.KeenSlider(container, sliderConfig, [WheelControls]);

            // Handle mouse movement
            const updateArrowPosition = (e) => {
                const rect = container.getBoundingClientRect();
                const x = e.clientX;
                const y = e.clientY;
                const quarter = Math.floor((x - rect.left) / (rect.width / 4));
                let showArrow = false;
                let rotate = 0;
                isInNavigationZone = false;

                if (quarter === 0 && !this.isAtStart) {
                    showArrow = true;
                    rotate = 180;
                    isInNavigationZone = true;
                } else if (quarter === 3 && !this.isAtEnd) {
                    showArrow = true;
                    rotate = 0;
                    isInNavigationZone = true;
                }

                // Position the arrow at cursor
                arrow.style.left = `${x}px`;
                arrow.style.top = `${y}px`;
                arrow.style.transform = `rotate(${rotate}deg)`;

                if (showArrow) {
                    arrow.style.visibility = 'visible';
                    arrow.style.opacity = '1';
                } else {
                    arrow.style.visibility = 'hidden';
                    arrow.style.opacity = '0';
                }
            };

            const hideArrow = () => {
                arrow.style.visibility = 'hidden';
                arrow.style.opacity = '0';
                isInNavigationZone = false;
            };

            container.addEventListener('mousemove', updateArrowPosition, { passive: true });
            container.addEventListener('mouseleave', hideArrow);

            // Prevent link clicks in navigation zones
            container.addEventListener('click', (e) => {
                const rect = container.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const quarter = Math.floor(x / (rect.width / 4));
                if (quarter === 0 && !this.isAtStart) {
                    e.preventDefault();
                    this.slider.prev();
                } else if (quarter === 3 && !this.isAtEnd) {
                    e.preventDefault();
                    this.slider.next();
                }
                // Otherwise, allow normal link clicks
            }, true);

            if (!this.hasInitialized) {
                this.hasInitialized = true;
            }
        }

        handleSlideChange(slider, container) {
            container.classList.add("keen-slider--initialized");
            
            // Update slide states
            slider.slides.forEach((element, idx) => {
                const portion = slider.track.details.slides[idx].portion;
                // element.classList.toggle('keen-slider__slide--active', portion === 1);
            });
        }

        disconnectedCallback() {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
            this.hasInitialized = false;
        }
    }

    window.customElements.define('header-carousel', HeaderCarousel);

}